import { bridge } from './bridge';
import { onScreenAll } from './visible';

/**
 * **서버에 맡겨 두고 나중에 끝나는 일.** 앱은 지로일괄발행·국세청 매출처리·엑셀 올리기 같은
 * 오래 걸리는 일을 `waitQueueStore` 대기열에 올리고 서버(lazytask)에 맡긴다. 끝나면 MQTT 로
 * 알림이 오고 대기열 항목이 「완료」가 된다. 결과(파일 받기 등)는 사람이 대기열에서 「실행」을
 * 눌러야 나온다.
 *
 * 턴은 그것을 기다리지 않는다 — 몇 분이 걸릴 수 있다. 버튼을 누른 뒤 **새로 올라간 항목**을
 * 돌려주고, 끝났는지는 패널이 지켜본다.
 */
export type QueuedJob = { key: string; title: string; startedAt: number };

type Entry = QueuedJob & { done: boolean };

/** 지금 대기열. 구버전 앱에는 통로가 없다 — 그때는 빈 목록이다. */
export function waitQueue(): Entry[] {
  try {
    return bridge().waitQueue?.() ?? [];
  } catch {
    return [];
  }
}

/** `before` 뒤에 새로 올라가 아직 안 끝난 항목. 같은 일(key)이 또 올라갈 수 있어 시각까지 본다. */
export function queuedSince(before: Entry[]): QueuedJob[] {
  const seen = new Set(before.map((one) => `${one.key}@${one.startedAt}`));
  return waitQueue()
    .filter((one) => !seen.has(`${one.key}@${one.startedAt}`))
    .map(({ key, title, startedAt }) => ({ key, title, startedAt }));
}

/**
 * 앱이 띄운 대기열 창을 닫는다. 창이 화면을 덮으면 다음 조작이 가려진다. 끝났는지는 패널이
 * 알려 주므로 사람이 이 창을 지켜볼 필요가 없다. 창의 단추는 `실행·재시도·모두 삭제·닫기` 뿐이다.
 */
export function closeWaitQueueWindow(): boolean {
  for (const modal of onScreenAll('[class*=ModalView]')) {
    if (!/대기열/.test(modal.textContent ?? '')) continue;
    const close = Array.from(modal.querySelectorAll<HTMLElement>('button'))
      .find((button) => (button.textContent ?? '').trim() === '닫기');
    if (close) {
      close.click();
      return true;
    }
  }
  return false;
}
